import { ActionMessageBuilder } from '@gogame/query';

export const messagesTapjoyBidUpdate = new ActionMessageBuilder(
  'Tapjoy Bid Update'
);
